// extracted by mini-css-extract-plugin
export var icon = "Icon-module--icon--39APs";
export var icon_color_yellow = "Icon-module--icon_color_yellow--1HBns";
export var icon_full = "Icon-module--icon_full--2ic07";